import React, { PureComponent } from 'react';
import styled from "styled-components";
import Sizes from "../Assets/Sizes";
import { FormattedMessage } from "react-intl";

import ParallelIcon from '@material-ui/icons/SwapHoriz';
import SequentialIcon from '@material-ui/icons/SwapVert';
import SwitchButton from "./SwitchButton";


const Wrapped = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`


const SideSelection = styled.div`
  opacity: ${ p => p.disabled ? 0.5 : 1 };
  display: flex;
  column-gap: ${ Sizes.smallMargin };
  transition: opacity 0.3s ease-in-out;
`;

export default class SimultaneousServicesSchedulingTypePicker extends PureComponent {
	toggle = (parallel) => {
		this.props.onChange(parallel);
	}

	sideClicked = (parallel, evt) => {
		evt.stopPropagation();
		evt.preventDefault();
		this.toggle(parallel);
	}

	render() {
		return (
			<Wrapped>
				<SideSelection disabled={ !this.props.parallel } onClick={ this.sideClicked.bind(this, true) }>
					<ParallelIcon/><FormattedMessage id={ 'schedule_parallel' }/>
				</SideSelection>
				<SwitchButton onChange={ () => this.toggle(!this.props.parallel) } active={ this.props.parallel }/>
				<SideSelection disabled={ this.props.parallel } onClick={ this.sideClicked.bind(this, false) }>
					<FormattedMessage id={ 'sequential_appointments' }/><SequentialIcon/>
				</SideSelection>
			</Wrapped>
		)
	}
}
